import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { AdminUsers } from "@/pages/admin/users";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/admin/users/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<AdminUsers />
		</DashboardLayout>
	);
}
